module.exports = __webpack_public_path__ + "assets/img/835d-bj.svg";